//CORE
import React from "react";
import Audit from '../components/Audit.js';
import ListOfValues from '../components/DataManagement/DataManagementDetailListOfValues.js';
import Locales from '../components/DataManagement/DataManagementDetailLocales.js';
import AppMenuItems from '../components/AppMenu/AppMenuItems.js';
import AppMenuItemRoutes from '../components/AppMenu/AppMenuItemRoutes.js';
import AppMenuItemRouteTabs from '../components/AppMenu/AppMenuItemRouteTabs.js';

//CUSTOM
import TankDetailBatches from '../components/Tank/TankDetailBatches.js';
import ProductDetailSKUs from '../components/Product/ProductDetailSKUs.js';
import ProductDetailAttachments from '../components/Product/ProductDetailAttachments.js';
import ProductDetailManufacturingOrders from '../components/Product/ProductDetailManufacturingOrders.js';
import SalesOrderDetailItems from '../components/SalesOrder/SalesOrderDetailItems.js';
import SalesOrderDetailEmailLog from '../components/SalesOrder/SalesOrderDetailEmailLog.js';
import StorageOrderDetailItems from '../components/StorageOrder/StorageOrderDetailItems.js';
import DeliveryPricingRuleCities from '../components/DeliveryPricingRule/DeliveryPricingRuleCities.js';
import AccountSalesOrders from "../components/Account/AccountSalesOrders.js";
import SKUDetailSalesOrderItem from "../components/SKU/SKUDetailSalesOrderItem.js";
import SKUDetailMultipacks from "../components/SKU/SKUDetailMultipacks.js";
import SKUDetailStockBalance from "../components/SKU/SKUDetailStockBalance.js";
import SKUDetailImages from "../components/SKU/SKUDetailImages.js";
import SKUDetailStorageOrderItem from "../components/SKU/SKUDetailStorageOrderItem.js";
import SKUDetailBatches from "../components/SKU/SKUDetailBatches.js";
import SKUDetailManufacturingOrders from "../components/SKU/SKUDetailManufacturingOrders.js";
import BatchDetailManufacturingOrders from "../components/Batch/BatchDetailManufacturingOrders.js";

const EntityComponentMap={
  accounts_accounts:React.lazy(()=>import('../components/Account/Accounts.js')),
  accounts_account:React.lazy(()=>import('../components/Account/AccountDetail.js')),
  accounts_account_new:React.lazy(()=>import('../components/Account/AccountNew.js')),
  tanks_tanks:React.lazy(()=>import('../components/Tank/Tanks.js')),
  tanks_tank:React.lazy(()=>import('../components/Tank/TankDetail.js')),
  tanks_tank_new:React.lazy(()=>import('../components/Tank/TankNew.js')),
  products_products:React.lazy(()=>import('../components/Product/Products.js')),
  products_product:React.lazy(()=>import('../components/Product/ProductDetail.js')),
  products_product_new:React.lazy(()=>import('../components/Product/ProductNew.js')),
  sales_orders_sales_orders:React.lazy(()=>import('../components/SalesOrder/SalesOrders.js')),
  sales_orders_sales_order:React.lazy(()=>import('../components/SalesOrder/SalesOrderDetail.js')),
  sales_orders_sales_order_new:React.lazy(()=>import('../components/SalesOrder/SalesOrderNew.js')),
  storage_orders_storage_orders:React.lazy(()=>import('../components/StorageOrder/StorageOrders.js')),
  storage_orders_storage_order:React.lazy(()=>import('../components/StorageOrder/StorageOrderDetail.js')),
  storage_orders_storage_order_new:React.lazy(()=>import('../components/StorageOrder/StorageOrderNew.js')),
  skus_skus:React.lazy(()=>import('../components/SKU/SKUs.js')),
  skus_sku:React.lazy(()=>import('../components/SKU/SKUDetail.js')),
  skus_sku_new:React.lazy(()=>import('../components/SKU/SKUNew.js')),
  gtins_gtins:React.lazy(()=>import('../components/GTIN/GTINs.js')),
  notifications_notifications:React.lazy(()=>import('../components/Notification/Notifications.js')),
  notifications_notification:React.lazy(()=>import('../components/Notification/Notification.js')),
  my_notifications_my_notifications:React.lazy(()=>import('../components/Notification/Notifications.js')),
  my_notifications_my_notification:React.lazy(()=>import('../components/Notification/Notification.js')),
  error_logs_error_logs:React.lazy(()=>import('../components/ErrorLog/ErrorLogs.js')),
  tank_scheduling_tank_scheduling_wrapper:React.lazy(()=>import('../components/TankScheduling/TankSchedulingWrapper.js')),
  tank_scheduling_tank_scheduling:React.lazy(()=>import('../components/TankScheduling/TankScheduling.js')),
  users_users:React.lazy(()=>import('../components/User/Users.js')),
  users_user:React.lazy(()=>import('../components/User/UserDetail.js')),
  users_user_new:React.lazy(()=>import('../components/User/UserDetailNew.js')),
  server_management_server_management:React.lazy(()=>import('../components/ServerManagement/ServerManagementDetail.js')),
  app_roles_app_roles:React.lazy(()=>import('../components/AppRole/AppRoles.js')),
  data_management_data_management:React.lazy(()=>import('../components/DataManagement/DataManagementDetail.js')),
  tags_tags:React.lazy(()=>import('../components/Tags/Tags.js')),
  alcohol_licenses_alcohol_licenses:React.lazy(()=>import('../components/AlcoholLicense/AlcoholLicenses.js')),
  package_types_package_types:React.lazy(()=>import('../components/PackageTypes/PackageTypes.js')),
  delivery_pricing_rules_delivery_pricing_rules:React.lazy(()=>import('../components/DeliveryPricingRule/DeliveryPricingRules.js')),
  delivery_pricing_rules_delivery_pricing_rule:React.lazy(()=>import('../components/DeliveryPricingRule/DeliveryPricingRuleDetail.js')),
  delivery_pricing_rules_delivery_pricing_rule_new:React.lazy(()=>import('../components/DeliveryPricingRule/DeliveryPricingRuleNew.js')),
  app_menus_app_menus:React.lazy(()=>import('../components/AppMenu/AppMenus.js')),
  app_menus_app_menu:React.lazy(()=>import('../components/AppMenu/AppMenuDetail.js')),
  app_menus_app_menu_item:React.lazy(()=>import('../components/AppMenu/AppMenuItemDetail.js')),
  app_menus_app_menu_item_route:React.lazy(()=>import('../components/AppMenu/AppMenuItemRouteDetail.js')),
  manufacturing_orders_manufacturing_orders:React.lazy(()=>import('../components/ManufacturingOrder/ManufacturingOrders.js')),
  manufacturing_orders_manufacturing_order:React.lazy(()=>import('../components/ManufacturingOrder/ManufacturingOrderDetail.js')),
  manufacturing_orders_manufacturing_order_new:React.lazy(()=>import('../components/ManufacturingOrder/ManufacturingOrderNew.js')),
  batches_batches:React.lazy(()=>import('../components/Batch/Batches.js')),
  batches_batch:React.lazy(()=>import('../components/Batch/BatchDetail.js')),
};

export const getEntityComponent=(entity)=>EntityComponentMap[entity]||null;

const PageTabComponentMap={
    account:{
      sales_orders:AccountSalesOrders,
      audit:Audit,
    },
    sales_order:{
      items:SalesOrderDetailItems,
      email_log:SalesOrderDetailEmailLog,
      audit:Audit,
    },
    storage_order:{
      items:StorageOrderDetailItems,
      audit:Audit,
    },
    tank:{
      batches:TankDetailBatches,
      audit:Audit,
    },
    product:{
      skus:ProductDetailSKUs,
      attachments:ProductDetailAttachments,
      manufacturing_orders:ProductDetailManufacturingOrders,
      audit:Audit,
    },
    sku:{
      sales_order_items:SKUDetailSalesOrderItem,
      storage_order_items:SKUDetailStorageOrderItem,
      batches:SKUDetailBatches,
      multipacks:SKUDetailMultipacks,
      stock_balance:SKUDetailStockBalance,
      images:SKUDetailImages,
      manufacturing_orders:SKUDetailManufacturingOrders,
      audit:Audit,
    },
    batch:{
      manufacturing_orders:BatchDetailManufacturingOrders,
      audit:Audit,
    },
    manufacturing_order:{
      audit:Audit,
    },
    delivery_pricing_rule:{
      cities:DeliveryPricingRuleCities,
      audit:Audit,
    },
    user:{
      audit:Audit,
    },
    data_management:{
      list_of_values:ListOfValues,
      locales:Locales,
    },
    app_menu:{
      items:AppMenuItems,
      audit:Audit,
    },
    app_menu_item:{
      routes:AppMenuItemRoutes,
      audit:Audit,
    },
    app_menu_item_route:{
      route_tabs:AppMenuItemRouteTabs,
      audit:Audit,
    },
};

export const getPageTabComponent=(entityKey,tabKey)=>{
  const entityMap=PageTabComponentMap[entityKey];
  if(!entityMap) return null;
  return entityMap[tabKey]||null;
};
